import { render, staticRenderFns } from "./SoilBlock.vue?vue&type=template&id=6255a06a&scoped=true&"
import script from "./SoilBlock.vue?vue&type=script&lang=js&"
export * from "./SoilBlock.vue?vue&type=script&lang=js&"
import style1 from "./SoilBlock.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6255a06a",
  null
  
)

export default component.exports